module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-hakone-2-5e3226f2ca1d32c3d7f933d2b12afef1.webp";